import { ArrowUpRight, Cpu, BarChart3, Scale } from "lucide-react";

const CaseStudies = () => {
  const caseStudies = [
    {
      icon: Cpu,
      category: "Defence Tech",
      title: "Investment Strategy for the UK Defence Tech Market",
      description:
        "Designed and executed a UK-focused fundraising strategy, combining targeted outreach to defence tech investors with visibility at key events (including a speaking slot at London Tech Week and defence tech demo days). This resulted in meetings and ongoing conversations with strategic stakeholders such as NSSIF, UK MoD, the Foreign, Commonwealth & Development Office, the Department for Business and Trade, and techUK.",
      tags: ["Fundraising Strategy", "Defence Tech", "UK Market"],
    },
    {
      icon: BarChart3,
      category: "Defence Expo",
      title: "SSD 2025 – Tallinn Defence Expo",
      description:
        "Planned and executed an expo strategy for SSD 2025 in Tallinn, securing 20+ pre-booked meetings with qualified partners, industry leads, and Ministry of Defence representatives.",
      tags: ["Expo Strategy", "Business Development", "Defence"],
    },
    {
      icon: Scale,
      category: "AI LegalTech",
      title: "AI LegalTech Product Launch",
      description:
        "Developed the positioning, product narrative, and go-to-market strategy for an AI legaltech platform entering the US and EU markets. Supported the creation of investor-facing materials, resulting in a clear fundraising story and readiness for early investor outreach.",
      tags: ["Product Positioning", "GTM Strategy", "Fundraising"],
    },
  ];

  return (
    <section id="case-studies" className="py-24 md:py-32 bg-muted/30">
      <div className="container px-6">
        {/* Section header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4 line-glow inline-block">
            Case Studies
          </h2>
          <p className="text-lg text-muted-foreground mt-6">
            Real results for innovative companies
          </p>
        </div>

        {/* Case studies grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {caseStudies.map((study, index) => (
            <div
              key={index}
              className="group p-8 rounded-xl border border-border bg-card hover:border-primary/30 transition-all duration-300 hover:shadow-card flex flex-col"
            >
              {/* Header */}
              <div className="flex items-start justify-between mb-6">
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors duration-300">
                  <study.icon className="w-6 h-6 text-primary" />
                </div>
                <span className="text-xs font-medium px-3 py-1 rounded-full bg-secondary text-secondary-foreground">
                  {study.category}
                </span>
              </div>

              {/* Content */}
              <h3 className="font-display text-lg font-semibold text-foreground mb-3 group-hover:text-primary transition-colors duration-300">
                {study.title}
              </h3>
              <p className="text-sm text-muted-foreground mb-6 flex-grow">
                {study.description}
              </p>

              {/* Tags */}
              <div className="flex flex-wrap gap-2">
                {study.tags.map((tag, tagIndex) => (
                  <span
                    key={tagIndex}
                    className="text-xs px-2 py-1 rounded bg-muted text-muted-foreground"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
